import { getClient } from '@api/client';
import { graphql } from '@api/generated';
import {
  CallTransferStatus,
  WarmTransferDestinationType,
} from '@api/generated/graphql';

export const getWorkflowTransferStatusQuery = graphql(`
  query GetWorkflowTransferStatus($sid: ID!, $transferInitiatorAgentId: ID!) {
    workflowTransferStatus(
      sid: $sid
      transferInitiatorAgentId: $transferInitiatorAgentId
    ) {
      status
      answeredByType
    }
  }
`);

export type GetWorkflowTransferStatusResult = {
  status: CallTransferStatus | null;
  answeredByType: WarmTransferDestinationType | null;
};

/**
 * Fetches the workflow transfer status for a given conversation SID and transfer initiator agent ID.
 */
export const getWorkflowTransferStatus = async (
  sid: string,
  transferInitiatorAgentId: string,
): Promise<GetWorkflowTransferStatusResult> => {
  const { data, error } = await getClient().query({
    query: getWorkflowTransferStatusQuery,
    variables: { sid, transferInitiatorAgentId },
    fetchPolicy: 'network-only',
  });

  if (error) {
    throw new Error(error.message);
  }

  return {
    status: data?.workflowTransferStatus?.status ?? null,
    answeredByType: data?.workflowTransferStatus?.answeredByType ?? null,
  };
};
